import { render, staticRenderFns } from "./EditNick.vue?vue&type=template&id=b35101da&scoped=true"
import script from "./EditNick.vue?vue&type=script&lang=js"
export * from "./EditNick.vue?vue&type=script&lang=js"
import style0 from "./EditNick.vue?vue&type=style&index=0&id=b35101da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35101da",
  null
  
)

export default component.exports